import { Component, OnInit,Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {ReportService} from "../service/report.service";
import { TrackerService } from '../service/tracker.service';

@Component({
  selector: 'app-dialog-container',
  templateUrl: './dialog-container.component.html',
  styleUrls: ['./dialog-container.component.scss']
})
export class DialogContainerComponent implements OnInit {
  public concept;
  public concepts;
  public currentConceptIndex;
  public method;
  public file;

  public details;
  // public concept = {
  //   "img": "https://neilpatel.com/wp-content/uploads/2017/08/url.jpg",
  //   "title": "Image Title",
  //   "profession": "profession",
  //   "kpis": {
  //       "Likeability": "90%",
  //       "Oil Brand Fit": "95%",
  //       "Recall": "91%"
  //   },
  //   "priority": 1
  // }

  constructor(public reportService:ReportService,public trackerService:TrackerService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
      this.method = data.method;
    }

  ngOnInit() {
    if(this.method == 'concept'){
      this.currentConceptIndex = this.data.index;
      this.concepts = this.reportService.researchDetails.concepts_details;
      // console.log('this.concepts',this.concepts);
      this.concept = this.concepts[this.currentConceptIndex];
    }
    else if(this.method == 'fileDelete'){
      this.file = this.data.file;
    }else if(this.method == 'notifySameFile'){
      this.details = this.data.details;
    } else if(this.method == 'translation_error_warning'){
      this.details = this.data.details;
    }
  }


  showPreviousImage(){
    this.currentConceptIndex--;
    this.concept = this.concepts[this.currentConceptIndex];
    this.submitTracker();
  }

  showNextImage(){
    this.currentConceptIndex++;
    this.concept = this.concepts[this.currentConceptIndex];
    this.submitTracker();
  }

  submitTracker(){
    let data = {}
    data['uuid'] = this.reportService.studyId;
    data['file_type'] = 'dynaview';
    data['action'] = 'view';
    data['misc'] = {'concept':this.concept};
    if (data['uuid'] && data['uuid'] != '') {
      this.trackerService.submitTracker(data);
    }
  }
  deleteFile(){
    // this.reportService.fileDeletionEvent.emit(this.file);
    if(this.method == 'fileDelete'){
      this.reportService.deleteCurrentFile(this.file,this.data.studyUUID);
    }else if(this.method == 'notifySameFile'){
      this.reportService.showPogress = false;
      this.reportService.uploadMultipleFile(this.details.study_uuid,this.details.job_id);
    } else if(this.method == 'translation_error_warning'){
      this.reportService.showPogress = false;
    }
    
  }

  noReplace(){
    this.reportService.showPogress = false;
    this.reportService.CloseUploadPanel();
  }

}
